import { motion } from "framer-motion";
import { news } from "./data";
import { SectionHeading } from "./Engines";

export function NewsImpact() {
  return (
    <section id="news" className="relative py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Market Impact"
          title="Macro events, priced before they print."
          sub="The News Engine grades each release, pauses execution through the window and re-opens on confirmation."
        />

        <div className="relative">
          <div className="absolute top-0 bottom-0 left-3 w-px bg-border/70 sm:left-4" />
          <div className="space-y-4">
            {news.map((n, i) => (
              <motion.article
                key={n.title}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="glass glass-hover relative ml-10 rounded-2xl p-5 sm:ml-14"
              >
                <span
                  className={`absolute top-7 -left-[2.15rem] h-3 w-3 rounded-full sm:-left-[2.65rem] ${
                    n.impact === "high" ? "bg-bear" : "bg-warn"
                  }`}
                />
                <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-4">
                  <div className="min-w-0">
                    <p className="font-mono text-[11px] text-muted-foreground">{n.time}</p>
                    <h3 className="mt-1 text-lg font-semibold">{n.title}</h3>
                  </div>
                  <div className="flex shrink-0 flex-col items-end gap-2">
                    <span
                      className={`rounded-full border px-3 py-1 text-[10px] tracking-[0.16em] uppercase ${
                        n.impact === "high"
                          ? "border-bear/40 bg-bear/10 text-bear"
                          : "border-warn/40 bg-warn/10 text-warn"
                      }`}
                    >
                      {n.impact} impact
                    </span>
                    <span className="text-[10px] tracking-[0.2em] text-muted-foreground uppercase">
                      {n.phase}
                    </span>
                  </div>
                </div>
                <p className="mt-4 rounded-lg border border-primary/20 bg-primary/5 p-3 text-sm text-muted-foreground">
                  <span className="text-primary">AI Insight · </span>
                  {n.insight}
                </p>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
